import { gql } from "@apollo/client";

export const GET_ALL_ESTADOS_RECLAMO = gql`
  query allEstadosReclamo {
    allEstadosReclamo {
        idEstadoReclamo
        descripcion
    }
}`;